import React, { useState } from "react";
import './Login.css';
import logo from '../logo.png';
import {useNavigate} from "react-router-dom";
import api from '../services/api';
/* import  secureLocalStorage  from  "react-secure-storage"; */
  
function Resetarsenha() {

document.body.classList.replace(document.body.className,'loginform');

const [senha, setSenha] = useState("");
const [senhac, setSenhac] = useState("");
const [retws, setRetws] = useState("");
const [retwsb, setRetwsb] = useState("");
const navigate = useNavigate();
const queryParams = new URLSearchParams(window.location.search);
const token = queryParams.get('token');
//console.log(token);

async function resetar(){
    setRetws("");
    setRetwsb("");

    if (senha === "" || senhac === ""){
      setRetws("Informe a senha");
      return;
    };

    if (senha !== senhac){
      setRetws("As senhas não conferem!");
      setSenha("");
      setSenhac("");
      return;
    }

    try {
      const response = await api.post('/accounts/reset-password',{
        "token": token,
        "password": senha,
        "confirmPassword": senhac
      });

      //console.log(response);
      setRetwsb(response.data.message);
      setTimeout(() => navigate('/login'), 180000);
    } catch (error) {
      setRetws(error.response.data.message);
      setSenha("");
      setSenhac("");
    }
  }; 

  const Resposta = () => {
    if (retws === "") return null;
  
    return (
      <label className="retlabelslogin">
            <h5 className="retlabelslogin">{retws}</h5>
      </label>
    );
  };

  const Respostab = () => {
    if (retwsb === "") return null;
  
    return (
      <label className="retlabelsloginb">
            <h5 className="retlabelsloginb">{retwsb}</h5>
      </label>
    );
  };

  return (
      <main className="loginform">
        <div className="loginquad">
          <img className="loginlogo" src={logo} alt="Logo" />
          <h2 className="logintitulo2">Redefinição de senha</h2>
          <label className="loginlabels">
               <strong className="loginlabels">Nova senha</strong>
          </label>

          <input className="logininputs"
          value={senha}
          type="password" 
          name="password" 
          onChange={(event) => setSenha(event.target.value)}
          placeholder="Informe a senha"
          />  

          <input className="logininputs"
          value={senhac}
          type="password" 
          name="password" 
          onChange={(event) => setSenhac(event.target.value)}
          placeholder="Confirme a senha"
          />  

          <button className="loginbtn" onClick={resetar}>
            REDEFINIR SENHA
          </button> 

          <Resposta />
          <Respostab />

        </div> 
      </main>
  );
}

export default Resetarsenha;
